import React from 'react'
import ReactApexChart from "react-apexcharts";
import { Card, CardBody } from 'reactstrap'
import { ApexOptions } from 'apexcharts';

function Inquiries({customerInquiries}) {
  const totalInquiries = customerInquiries.total;
  const resolvedPercentage = Math.round((customerInquiries.resolved / totalInquiries) * 100);
  const pendingPercentage = Math.round((customerInquiries.pending / totalInquiries) * 100);

  const chartOptions: ApexOptions = {
    chart: {
      height: 330,
      type: "radialBar",
    },
    plotOptions: {
      radialBar: {
        offsetY: 0,
        startAngle: 0,
        endAngle: 270,
        hollow: {
          size: "30%",
          background: "transparent",
          image: undefined,
        },
        dataLabels: {
          name: {
            show: true,
          },
          value: {
            show: true,
            fontSize: "16px",
            formatter: function (val) {
              return val + "%";
            }
          },
          total: {
            show: true,
            label: 'Total',
            formatter: function () {
              return totalInquiries + ' Inquiries';
            }
          }
        }
      }
    },
    colors: ['#34c38f', '#f1b44c'],
    labels: ['Resolved', 'Pending'],
    legend: {
      show: true,
      floating: true,
      fontSize: '13px',
      position: 'left',
      offsetX: 10,
      offsetY: 10,
      labels: {
        useSeriesColors: true
      },
      formatter: function(seriesName, opts) {
        const value = opts.w.globals.series[opts.seriesIndex];
        const count = seriesName === 'Resolved' ? customerInquiries.resolved : customerInquiries.pending;
        return seriesName + ": " + count + " (" + value + "%)";
      },
      markers: {
        size: 0
      }
    }
  };

  return (
    <Card>
      <CardBody>
        <div className="d-flex align-items-center">
          <h4 className="card-title flex-grow-1 mb-0">Customer Inquiries</h4>
        </div>
        <div>
          <ReactApexChart
            options={chartOptions}
            series={[resolvedPercentage, pendingPercentage]}
            type="radialBar"
            height={330}
          />
        </div>
      </CardBody>
    </Card>
  )
}

export default Inquiries
